
<template>
    <div class="center">
      <vs-dialog v-model="active" prevent-close :not-close="feedback.obligatoria" scroll overflow-hidden width="800px">
        <template #header>
          <h4 class="not-margin">
            {{feedback.titulo}}
          </h4>
        </template>

        <div class="con-form">
            <p class="mb-0">{{feedback.descripcion}}</p>
            <p><small style="color: #CB4335">* Preguntas requeridas</small></p>         
          <div v-for="(ask, a) in feedback.preguntas" :key="a">
            <div v-if="ask.tipo == 'opcion_multiple'">
              <h6>{{ask.orden + '.'}} {{ask.contenido}} <span v-if="ask.requerida">*</span></h6>
              <div class="d-flex justify-content-between" >
                  <vs-radio v-for="(answer, an) in ask.opciones" :key="an" class="m-2" v-model="respuestas[a].answer" :val="answer.id">
                    {{answer.contenido}}
                  </vs-radio>
              </div>
              <div class="vs-input__message vs-input__message--danger v-enter-to">
                  <span v-if="errorFields.includes('ask' + a)">Requerido</span>
              </div>
              <hr>
            </div>
            <div v-if="ask.tipo == 'verdadero_falso_comentario'">
              <h6>{{ask.orden + '.'}} {{ask.contenido}} <span v-if="ask.requerida">*</span></h6>
              <div class="d-flex" >
                  <vs-radio class="m-2" v-model="respuestas[a].answer" val="Si">
                    Si
                  </vs-radio>
                  <vs-radio class="m-2" v-model="respuestas[a].answer" val="No">
                    No
                  </vs-radio>
                  <vs-input v-if="respuestas[a].answer == 'No'" v-model="respuestas[a].comentario" placeholder="¿Por qué?" />
              </div>
              <div class="vs-input__message vs-input__message--danger v-enter-to">
                  <span v-if="errorFields.includes('ask' + a)">Requerido</span>
              </div>
              <hr>
            </div>
            <div v-if="ask.agrupadas">
              <div class="mt-3">
                <h6>{{ask.orden + '.'}} {{ask.instruccion_general}}</h6>
                <div v-for="(estrella, e) in ask.preguntas" :key="e" class="mt-3">
                  <p><strong>{{estrella.contenido}}</strong><span v-if="ask.requerida">*</span></p>
                  <div class="d-flex align-items-center justify-content-center">
                    <p class="mb-0 text-uppercase"><strong><small>{{estrella.texto_valores[0]}}</small></strong></p>
                    <div class="rating" >
                      <template v-for="(star, s) in parseInt(estrella.valores[1])">
                        <input v-model="respuestas[a][e].answer"  :key="'s' + s" type="radio" :id="'star' + (e + 1) + (estrella.valores[1] - s)" :name="'stars' + (e + 1) + (estrella.valores[1] - s)" :value="estrella.valores[1] - s">
                        <label :key="'l' + s" :for="'star' + (e + 1) + (estrella.valores[1] - s)"><i class="fas fa-star"></i></label>
                      </template>
                    </div>
                    <p class="mb-0 text-uppercase"><strong><small>{{estrella.texto_valores[1]}}</small></strong></p>
                  </div>
                  <div class="vs-input__message vs-input__message--danger v-enter-to">
                    <span v-if="errorFields.includes(`ask${a}${e}`)">Requerido</span>
                  </div>
                </div>
              </div>
              <hr>
            </div>
            <div v-if="ask.tipo == 'abierta'">
              <h6>{{ask.contenido}} <span v-if="ask.requerida">*</span></h6>
              <textarea v-model="respuestas[a].answer" name="comentario" rows="5" cols="50" style="width: 100%;"></textarea>
              <div class="vs-input__message vs-input__message--danger v-enter-to">
                  <span v-if="errorFields.includes('ask' + a)">Requerido</span>
              </div>
              <hr>
            </div>
          </div>
        </div>

        <template #footer>
          <div>
            <vs-button
                class="ml-auto"
                success
                @click="saveAnswers()"
            >
                Enviar
            </vs-button>
          </div>
        </template>
      </vs-dialog>
    </div>
</template>
<script>
  import encuestas from '../../../api/requests/encuestas';

  export default {
    props: [
      'encuestaId',
      'userId',
      'personaRol'
    ],
    data:() => ({
      active: true,
      errorFields: [],
      feedback: [],
      respuestas: [],
      stars5: '',
      ask1: ''
    }),
    mounted () {
      this.getEncuesta(this.encuestaId);
    },
    methods:{
      getSaveAnswer(){
        let array = []
        const preguntas = this.feedback.preguntas
        preguntas.forEach(f => {
          // const info = []
          if(f.agrupadas){
            const agrup = []
            f.preguntas.forEach(p => {
              const obj = {
                feedback: p,
                answer: ''
              }
              agrup.push(obj)
            })
            array.push(agrup)
          }else{
            const info = {
              feedback: f,
              answer: ''
            }
            if(f.tipo == 'verdadero_falso_comentario'){
              info.comentario = ''
            }
            array.push(info)
          }
        })
        this.respuestas = array
      },
      sanityForm () {
          this.errorFields = []
          // Se hace el arreglo para saber que pregunta es requerida, este parametro de si es requerida se toma desde el JSON de preguntas
          this.respuestas.forEach((r, index) => {
            if(Array.isArray(r)){
              r.forEach((rr, i) => {
                if (!rr.answer && rr.feedback.requerida) {
                    this.errorFields.push(`ask${index}${i}`)
                }
              })

            }else if(r.feedback.requerida){
              if (!r.answer) {
                  this.errorFields.push('ask' + index)
              }
            }
          })
          if(!this.errorFields.length){
            return true
          }
      },
      getEncuesta(encuestaId){
        if (encuestaId) {
          encuestas.getEncuesta(encuestaId)
            .then(response => {
              this.feedback = response.data;
              this.getSaveAnswer()
            })
            .catch(error => {
              console.error('Error al cargar datos desde la API:', error);
            });
          
            // this.active = false
            // this.$refs.admin.resetInfo();
        }
      },
      async saveAnswers() {
        // Se guarda la información validando que las preguntas requeridas se han contestado 
        if(this.sanityForm()){
          const loading = this.$vs.loading()
          const answers = {
            encuesta_id: this.encuestaId,
            user_id: this.userId,
          }
          const obj = []
          const rest = this.respuestas.flat()
          rest.forEach(r => {
            const res = {
              pregunta_id: r.feedback.id,
              respuesta: r.answer,
              tipo: r.feedback.tipo
            }
            if(r.feedback.tipo == 'verdadero_falso_comentario'){
              if(r.answer == 'No'){
                res.respuesta = `${r.answer}. Comentario: ${r.comentario}`
              }
              res.tipo = 'texto'
            }
            obj.push(res)
          })
          answers.respuestas = obj
          const response = await fetch("/api/v1/encuestas/guardar", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(answers),
          });

          const data = await response.json();
          this.$vs.notification({
              progress: 'auto',
              color: 'success',
              position: null,
              title: data.message
          })
          this.active = false
          this.getSaveAnswer()
          loading.close()
        }
      
      }
    }
  }
</script>
<style lang="scss">
.justify-content-evenly{
  justify-content: space-evenly;
}
.rating {
  display: inline-block;
  transition: all .35s ease;
  margin: 0 1em;
  label {
    color: #c8dbdf;
    font-size: 1.5em;
    margin: 6px;
    float: right;
    cursor: pointer;
  }
  input[type="radio"] {
    display: none;
  }
}
.rating > input:checked ~ label {
  color: #F79426;
}
.rating:not(:checked) > label:hover,
.rating:not(:checked) > label:hover ~ label {
  color: #FECE31;
}
.rating > input:checked + label:hover,
.rating > input:checked ~ label:hover,
.rating > label:hover ~ input:checked ~ label,
.rating > input:checked ~ label:hover ~ label {
  color: #FECE31;
}

.borderBottom {
  padding: 0.8rem 0;
}

.borderBottom:not(:last-child){
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
</style>

        